export default "__VITE_ASSET__DbpHcqnB__"